module.exports = __webpack_public_path__ + "img/WT-search.08d34965.png";